import { render, staticRenderFns } from "./GiftBoxCampaignsOptionModal.vue?vue&type=template&id=8c05e2ea&scoped=true&"
import script from "./GiftBoxCampaignsOptionModal.vue?vue&type=script&lang=js&"
export * from "./GiftBoxCampaignsOptionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c05e2ea",
  null
  
)

export default component.exports